import AutoplaySwiper from "./components/swiper";
import { useEffect, useState } from "react";
import { Swiper as SwiperType } from "swiper";
import { GetExtractosLast, GetNumbersExtractosLast } from "./actions/actions";
import {
  IModalidades,
  INumeroExtracto,
  HeadExtractoLoteria,
} from "./interfaces/interfaces";
import GrillaResumen from "./components/grillaResumen";
import { Box, Button, Dialog, Menu, MenuItem } from "@mui/material";
import DialogContentBuscar from "./components/dialogContentBuscar";
import "typeface-roboto";
import { Search, VideoCall, Fullscreen } from "@mui/icons-material";
import DialogContentLive from "./components/dialogContentLive";
import moment from "moment";
require("moment/locale/es"); // Cargar configuración en español

function App() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [stateDialog, setStateDialog] = useState<boolean>(false);
  const [stateProxSorteo, setStateProxSorteo] = useState<number>(-99.0);
  const [stateDiffSorteo, setStateDiffSorteo] = useState<number[]>([]);
  const [stateDialogLive, setStateDialogLive] = useState<{
    estado: boolean;
    tipo: number;
  }>({ estado: false, tipo: 1 }); //abrir automaticamente

  const [currentModalidad, setCurrentModalidad] = useState<IModalidades>();
  const [actionsSwiper, setActionsSwiper] = useState<SwiperType>();
  const [lastHeadExtractos, setLastHeadExtractos] = useState<IModalidades[]>(
    []
  );
  const [lastNumerosExtractos, setLastNumerosExtractos] = useState<
    INumeroExtracto[]
  >([]);

  useEffect(() => {
    cargandoUltimosExtractos();
    const interval = setInterval(() => {
      cargandoUltimosExtractos();
    }, 22800);

    return () => clearInterval(interval); // Limpia el intervalo al desmontar el componente*/
  }, []);

  const actionArrowRight = () => {
    actionsSwiper?.slideNext();
  };

  const actionArrowLeft = () => {
    actionsSwiper?.slidePrev();
  };

  const getHeadModalidad = (modalidad: IModalidades) => {
    setCurrentModalidad(modalidad);
  };

  useEffect(() => {
    let diffFloatArray: number[] = [];
    for (const i in lastHeadExtractos) {
      const sorteo = lastHeadExtractos[i].items[0] as HeadExtractoLoteria;
      let diffFloat = openDialogLiveSorteo(sorteo);
      if (diffFloat < 0) diffFloatArray = [...diffFloatArray, diffFloat];
    }
    setStateDiffSorteo(diffFloatArray);
  }, [lastHeadExtractos]);

  const openDialogLiveSorteo = (sorteo: HeadExtractoLoteria) => {
    let fechaHoraString = `${sorteo.FechaProximoSorteo} ${sorteo.HoraSorteo}`;
    let fechaHoraSorteo = moment(
      `${fechaHoraString}`,
      "DD [de] MMMM [de] YYYY hh:mm"
    );

    let fechaHoraSorteoFin = moment(
      `${fechaHoraString}`,
      "DD [de] MMMM [de] YYYY hh:mm"
    ).add(25, "minutes");

    let now = moment();

    compareMoments(fechaHoraSorteo, now, fechaHoraSorteoFin);

    let diffFloat = setDiferenceMoments(fechaHoraSorteo);

    return diffFloat;
  };

  const compareMoments = (
    mSorteo: moment.Moment,
    now: moment.Moment,
    mSorteoFin: moment.Moment
  ) => {
    let r = stateDialogLive.estado;

    if (stateDialogLive.tipo === 1) {
      if (mSorteo.day() === now.day() && mSorteo.hour() === now.hour()) {
        r = now.isBetween(mSorteo, mSorteoFin, undefined, "[]");

        r
          ? setStateDialogLive({ estado: true, tipo: stateDialogLive.tipo })
          : setStateDialogLive({ estado: false, tipo: stateDialogLive.tipo });
      }
    }
  };

  useEffect(() => {
    let r = Math.max(...stateDiffSorteo);
    setStateProxSorteo(r ?? stateProxSorteo);
  }, [stateDiffSorteo]);

  const setDiferenceMoments = (mSorteo: moment.Moment) => {
    let now = moment();
    let diff = now.diff(mSorteo, "minutes");
    return diff;
  };

  useEffect(() => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });

    window.addEventListener("appinstalled", () => {
      window.location.reload();
    });
  }, []);

  return (
    <>
      <Button
        id="fade-button"
        style={{
          position: "inherit",
        }}
        aria-expanded={open ? "true" : undefined}
        onClick={handleClickMenu}
      >
        <img className="iconMenu" src="img/iconMenuHamburguer.png"></img>
      </Button>
      <section id="Menu">
        <Menu
          id="fade-menu"
          className="menuItems"
          anchorEl={anchorEl}
          open={open}
          onClose={handleCloseMenu}
          style={{
            top: "16px",

            left: "0px",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: 0,
          }}
        >
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              setStateDialog(!stateDialog);
            }}
          >
            <Search /> Buscar
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              toggleFullScreen();
            }}
          >
            <Fullscreen />
            Pantalla Completa
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              setStateDialogLive({
                estado: !stateDialogLive.estado,
                tipo: 2,
              });
            }}
          >
            <VideoCall /> Sorteo en vivo
          </MenuItem>
        </Menu>
      </section>

      <section id="Cabecera">
        <div className="logo">
          <img id="logoLoteria" src="img/logo_loteria.png"></img>
        </div>
        <div id="tituloSorteo">
          <div className="tituloSorteoContainer">
            <div className="extractosSorteoTitulo">{`${
              currentModalidad?.Modalidad ?? "Tómbola"
            }`}</div>
            <div className="extractosSorteoSubtitulo">
              Sorteo N°{" "}
              <span className="extractosTextBold">
                {`${currentModalidad?.NROSorteo ?? ""}`}
                {" | "}
                {`${currentModalidad?.FechaSorteoSTR ?? ""}`}
              </span>
            </div>
            <div className="extractosSorteoSubtitulo">
              Prescripcion{" "}
              <span className="extractosTextLightBold">
                {`${currentModalidad?.FechaPrescripcion ?? ""}`}
              </span>
            </div>
          </div>
        </div>
        <div className="logo">
          <img id="logoIafas" src="img/logo_iafas.png"></img>
        </div>
      </section>
      <div className="extractosGoLeft" onClick={() => actionArrowLeft()}>
        <img className="iconGo" src="img/iconArrowLeft.png"></img>
      </div>
      <section id="Extractos">
        {lastHeadExtractos && lastHeadExtractos.length > 0 && (
          <AutoplaySwiper
            lastHeadExtractos={lastHeadExtractos}
            numerosExtractos={lastNumerosExtractos}
            getHeadModalidad={getHeadModalidad}
            actionsButton={setActionsSwiper}
          />
        )}
      </section>
      <div className="extractosGoRight" onClick={() => actionArrowRight()}>
        <img className="iconGo" src="img/iconArrowRight.png"></img>
      </div>
      <section id="Resumen">
        {lastHeadExtractos && lastHeadExtractos.length > 0 && (
          <GrillaResumen
            lastHeadExtractos={lastHeadExtractos}
            numerosExtractos={lastNumerosExtractos}
            stateProxSorteo={stateProxSorteo}
          />
        )}
      </section>

      <Dialog
        open={stateDialog}
        onClose={() => setStateDialog(!stateDialog)}
        maxWidth={"xl"}
      >
        <Box
          style={{
            backgroundColor: "white",
          }}
        >
          <DialogContentBuscar handleClose={setStateDialog} />
        </Box>
      </Dialog>
      <>
        <Dialog
          open={stateDialogLive.estado}
          maxWidth={"xl"}
          onClose={() =>
            setStateDialogLive({
              estado: !stateDialogLive.estado,
              tipo: 2,
            })
          }
        >
          <Box
            style={{
              backgroundColor: "white",
            }}
          >
            <DialogContentLive
              stateDialogLive={stateDialogLive}
              handleClose={setStateDialogLive}
            />
          </Box>
        </Dialog>
      </>
    </>
  );

  function cargandoUltimosExtractos() {
    GetExtractosLast()
      .then((data) => {
        setLastHeadExtractos(data.data);
      })
      .catch((error) => {
        setLastHeadExtractos([]);
      });

    GetNumbersExtractosLast()
      .then((data) => {
        let copia = [
          ...data.data.map((elemento, index) => {
            elemento.id = index + 1;
            return elemento;
          }),
        ];

        setLastNumerosExtractos(copia);
      })
      .catch((error) => {
        setLastNumerosExtractos([]);
      });
  }

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
}
export default App;
